import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
// admin
import Dashboard from '@/views/Dashboard'
import UsersLogout from '@/views/components/users/logout'

// swan
import TopList from '@/views/components/swan/top/list'
import TopEdit from '@/views/components/swan/top/edit'
import SlideList from '@/views/components/swan/top_slide/list'
import SlideEdit from '@/views/components/swan/top_slide/edit'
import LayerList from '@/views/components/swan/layer/list'
import LayerEdit from '@/views/components/swan/layer/edit'
import NewsList from '@/views/components/swan/news/list'
import NewsEdit from '@/views/components/swan/news/edit'
import OverviewList from '@/views/components/swan/overview/list'
import OverviewEdit from '@/views/components/swan/overview/edit'
import FeatureList from '@/views/components/swan/feature/list'
import FeatureEdit from '@/views/components/swan/feature/edit'
import WorkEdit from '@/views/components/swan/work/edit'
import WorkPickup from '@/views/components/swan/work/PickupEdit'
import WorkTop from '@/views/components/swan/work/top'
import FaqList from '@/views/components/swan/faq/list'
import FaqEdit from '@/views/components/swan/faq/edit'
import TechInfoList from '@/views/components/swan/techInfo/list'
import TechInfoEdit from '@/views/components/swan/techInfo/edit'
import ContactList from '@/views/components/swan/contact/list'
import ContactEdit from '@/views/components/swan/contact/edit'
import OrderList from '@/views/components/swan/order/list'
import OrderEdit from '@/views/components/swan/order/edit'
import StaticList from '@/views/components/swan/static/list'
import StaticEdit from '@/views/components/swan/static/edit'
import SettingList from '@/views/components/swan/setting/list'
import SettingEdit from '@/views/components/swan/setting/edit'

// Views - Pages
import Page404 from '@/views/Page404'
import Page500 from '@/views/Page500'
import Login from '@/views/Login'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/swan/top/',
          name: 'TopList',
          component: TopList
        },
        {
          path: '/swan/top/edit',
          name: 'TopEdit',
          component: TopEdit
        },
        {
          path: '/swan/top_slide/',
          name: 'SlideList',
          component: SlideList
        },
        {
          path: '/swan/top_slide/edit',
          name: 'SlideEdit',
          component: SlideEdit
        },
        {
          path: '/swan/layer/',
          name: 'LayerList',
          component: LayerList
        },
        {
          path: '/swan/layer/edit',
          name: 'LayerEdit',
          component: LayerEdit
        },
        {
          path: '/swan/news/',
          name: 'NewsList',
          component: NewsList
        },
        {
          path: '/swan/news/edit',
          name: 'NewsEdit',
          component: NewsEdit
        },
        {
          path: '/swan/overview/',
          name: 'Overview',
          component: OverviewList
        },
        {
          path: '/swan/overview/edit',
          name: 'Overview',
          component: OverviewEdit
        },
        {
          path: '/swan/feature/',
          name: 'Feature',
          component: FeatureList
        },
        {
          path: '/swan/feature/edit',
          name: 'Feature',
          component: FeatureEdit
        },
        {
          path: '/swan/work/edit',
          name: 'WorkEdit',
          component: WorkEdit
        },
        {
          path: '/swan/work/pickup',
          name: 'WorkPickup',
          component: WorkPickup
        },
        {
          path: '/swan/work/',
          name: 'WorkTop',
          component: WorkTop
        },
        {
          path: '/swan/faq/',
          name: 'FaqTop',
          component: FaqList
        },
        {
          path: '/swan/faq/edit',
          name: 'FaqEdit',
          component: FaqEdit
        },
        {
          path: '/swan/techInfo/',
          name: 'TechInfoTop',
          component: TechInfoList
        },
        {
          path: '/swan/techInfo/edit',
          name: 'TechInfoEdit',
          component: TechInfoEdit
        },
        {
          path: '/swan/contact/',
          name: 'Contact',
          component: ContactList
        },
        {
          path: '/swan/contact/Edit',
          name: 'Contact',
          component: ContactEdit
        },
        {
          path: '/users/logout',
          name: 'UsersLogout',
          component: UsersLogout
        },
        {
          path: '/swan/order/',
          name: 'OrderTop',
          component: OrderList
        },
        {
          path: '/swan/order/edit',
          name: 'OrderEdit',
          component: OrderEdit
        },
        {
          path: '/swan/static/',
          name: 'Static',
          component: StaticList
        },
        {
          path: '/swan/static/edit',
          name: 'StaticEdit',
          component: StaticEdit
        },
        {
          path: '/swan/setting/',
          name: 'Setting',
          component: SettingList
        },
        {
          path: '/swan/setting/edit',
          name: 'SettingEdit',
          component: SettingEdit
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/404',
      name: 'Page404',
      component: Page404
    },
    {
      path: '/500',
      name: 'Page500',
      component: Page500
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js